/* global axios */

import ApiClient from './ApiClient';

class RealEstateFinanceCompanyTransfersAPI extends ApiClient {
  constructor() {
    super('real_estate_finance_company_transfers', { accountScoped: true });
  }

  createTransfer(payload, onUploadProgress) {
    const formData = new FormData();
    formData.append('installment_id', payload.installmentId);
    formData.append('agency_profile_id', payload.agencyProfileId);
    formData.append('amount_cents', payload.amountCents);
    formData.append('transferred_on', payload.transferredOn);
    formData.append('observation', payload.observation);
    formData.append('receipt', payload.receipt);
    formData.append('idempotency_key', payload.idempotencyKey);

    return axios.post(this.url, formData, { onUploadProgress });
  }

  downloadReceipt(id) {
    return axios.get(`${this.url}/${id}/download_receipt`);
  }
}

export default new RealEstateFinanceCompanyTransfersAPI();
